import {
    TextField,
    MenuItem,
    Typography,
    Divider,
    Button,
} from "@mui/material";

export default function CropInfoSection({
    form,
    setForm,
    cropTypes,
    cropVarieties,
    translate,
    fieldSx,
    onSuggestClick,
    errors = {},
}) {
    const normalizedCropTypes =
        Array.isArray(cropTypes?.[0])
            ? cropTypes[0]
            : cropTypes || [];

    const normalizedVarieties =
        Array.isArray(cropVarieties?.[0])
            ? cropVarieties[0]
            : cropVarieties || [];
    const getFieldSx = (hasError) => ({
        ...fieldSx,
        "& .MuiOutlinedInput-root": hasError
            ? {
                  "& fieldset": {
                      borderColor:
                          "var(--color-green-strong)",
                  },
                  "&:hover fieldset": {
                      borderColor:
                          "var(--color-green-strong)",
                  },
                  "&.Mui-focused fieldset": {
                      borderColor:
                          "var(--color-green-strong)",
                  },
              }
            : {},
    });

    const helperTextStyle = {
        mt: 0.5,
        fontSize: 12,
        color: "var(--color-green-strong)",
    };

    return (
        <>
            <Divider sx={{ my: 4 }} />

            <Typography
                variant="subtitle1"
                sx={{ mb: 1 }}
            >
                {translate("crop_information")}
            </Typography>

            <Button
                variant="text"
                size="small"
                sx={{
                    mt: 1,
                    alignSelf: "flex-start",
                }}
                onClick={onSuggestClick}
            >
                {translate(
                    "i_dont_see_my_crop"
                )}
            </Button>
            <TextField
                select
                label={translate("crop_type")}
                fullWidth
                required
                value={form.crop_type}
                onChange={(e) =>
                    setForm((prev) => ({
                        ...prev,
                        crop_type: e.target.value,
                    }))
                }
                sx={getFieldSx(
                    !!errors.crop_type
                )}
            >
                {normalizedCropTypes.map((t) => (
                    <MenuItem
                        key={t.crop_type_id}
                        value={t.crop_type_id}
                    >
                        {t.crop_name}
                    </MenuItem>
                ))}
            </TextField>

            {errors.crop_type && (
                <Typography
                    sx={helperTextStyle}
                >
                    {translate(
                        errors.crop_type
                    )}
                </Typography>
            )}

            <TextField
                select
                label={translate(
                    "crop_variety"
                )}
                fullWidth
                required
                disabled={!form.crop_type}
                value={form.crop_variety}
                onChange={(e) =>
                    setForm((prev) => ({
                        ...prev,
                        crop_variety:
                            e.target.value,
                    }))
                }
                sx={fieldSx}
            >
                {normalizedVarieties.map((v) => (
                    <MenuItem
                        key={v.crop_variety_id}
                        value={
                            v.crop_variety_id
                        }
                    >
                        {v.variety_name}
                    </MenuItem>
                ))}
            </TextField>

        </>
    );
}